import { render, staticRenderFns } from "./TitleView.vue?vue&type=template&id=1aa67fb8&"
import script from "./TitleView.vue?vue&type=script&lang=js&"
export * from "./TitleView.vue?vue&type=script&lang=js&"
import style0 from "./TitleView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports